import React, { useCallback, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';
import AnchorDashboardStore from '../../../store/fragments/AnchorDashboardStore';


// import Avatar from '@material-ui/core/Avatar';

import './css/BroadcastChatMessage.css';
import './css/BroadcastChatMessage.mobile.css';
import CAM4_BADGE from '../../../assets/Hedonism/cam4-badge.png';
import TEMPTED_BADGE from '../../../assets/Hedonism/tempted-badge.png';
import NAKEDNEWS_BADGE from '../../../assets/Hedonism/nakednews-badge.png';

import SocialIcon from './SocialIcon';
import ViewDraftjsText from '../../ViewDraftjsText/ViewDraftjsText';
import { observer } from 'mobx-react';


// function generateUsernameIntials(username) {
//   const initials = username.split(" ").map(word=> word[0].toUpperCase()).join('');
//   return initials;
// }

const WISH_TIPPING = 'wishTipping';
const WISH_COMPLETED = 'wishCompleted';
const CAM4_TIPPING = 'cam4Tipping';

const ChatMessage = (props) => {
  const {
    anchors,
    metadata,
    isSpotlight,
    attributes,
    isInGroupShow,
    message: propsMessage,
    nickname,
    username,
    user,
    source,
  } = props;
  const name = useMemo(() => nickname || username, [nickname, username]);
  const isMineMessage = useMemo(() => user.user && username === user.user.username, [user.user, username]);
  const isTippingMessage = useMemo(() => attributes && attributes.type === 'tippingEvent', [attributes]);
  const isWishTippingMessage = useMemo(() =>
    isTippingMessage && attributes?.subType === WISH_TIPPING, [attributes, isTippingMessage]);
  const isWishCompletedMessage = useMemo(() => attributes?.type === WISH_COMPLETED, [attributes]);
  const wishOwnerNickname = attributes?.wishOwnerNickname;
  const isSimpleTippingMessage = useMemo(() =>
    !isWishTippingMessage && !isInGroupShow && !isSpotlight, [isInGroupShow, isSpotlight, isWishTippingMessage]);
  const isCAM4TokenTipMessage = useMemo(() =>
    attributes?.subType === CAM4_TIPPING || attributes?.isFromCam4, [attributes]);
  let messageBadge = useMemo(() => {
    if (isCAM4TokenTipMessage) {
      return CAM4_BADGE;
    }

    return TEMPTED_BADGE;
  }, [isCAM4TokenTipMessage]);
  messageBadge = useMemo(() => {
    if (isMineMessage) {
      return NAKEDNEWS_BADGE;
    }

    return messageBadge;
  }, [isMineMessage, messageBadge]);
  const isAnchor = user?.user?.account?.anchor?.id;

  const calculateTipAmount = useCallback(() => {
    if (attributes?.tipsAmmount && !isCAM4TokenTipMessage) {
      return (attributes?.tipsAmmount % 5 === 0 ? attributes?.tipsAmmount : attributes?.tipsAmmount - 1);
    }

    return parseInt(attributes?.tipsAmount, 10);
  }, [attributes?.tipsAmmount, attributes?.tipsAmount, isCAM4TokenTipMessage]);

  const getDisplayName = useCallback(() => {
    if (!isAnchor) {
      return name;
    }
    const { fanAliases } = AnchorDashboardStore;

    return fanAliases?.[username]?.displayUsername || name;
  }, [isAnchor, name, username]);

  const replaceDisplayName = useCallback((messageToFormat) => {
    if (!isAnchor) {
      return messageToFormat;
    }

    return messageToFormat?.replace(nickname, getDisplayName());
  }, [getDisplayName, isAnchor, nickname]);

  const message = useMemo(() => {
    const { tippedStarNickname, nickname, tipsAmmount } = attributes || {};
    if (isInGroupShow) {
      return replaceDisplayName(propsMessage);
    }
    if (isSpotlight && isTippingMessage && tippedStarNickname && nickname && tipsAmmount) {
      return `${getDisplayName(nickname)} has tipped ${tippedStarNickname} $${calculateTipAmount(attributes)}`;
    }

    return propsMessage;
  }, [attributes, calculateTipAmount, getDisplayName, isInGroupShow, isSpotlight, isTippingMessage, propsMessage, replaceDisplayName]);

  const getTipMessage = useCallback(() => {
    if (isInGroupShow || isSpotlight) {
      return (
        <span>
          <img alt="cam4" className="message-badge tip" src={messageBadge} />
          <ViewDraftjsText
            allAnchors={anchors}
            metadata={metadata}
            text={message}
          />
        </span>
      );
    }

    if (isWishTippingMessage) {
      return (
        <span>
          <b>{getDisplayName(username)}</b> participated in the Tempting Wish with <b>${calculateTipAmount(attributes)}</b>
        </span>
      );
    }
    if (isSimpleTippingMessage && !isCAM4TokenTipMessage) {
      return (
        <span>
          <img alt="cam4" className="message-badge tip" src={messageBadge} />
          <b>{getDisplayName(username)}</b> tipped <b>${calculateTipAmount(attributes)}</b>
        </span>
      );
    }
    if (isCAM4TokenTipMessage) {
      return (
        <span>
          <img alt="cam4" className="message-badge tip" src={messageBadge} />
          <b>{getDisplayName(username)}</b> tipped <b>{calculateTipAmount(attributes)} {attributes?.tipsCurrency}s</b>
        </span>
      );
    }
  }, [
    anchors,
    attributes,
    calculateTipAmount,
    getDisplayName,
    isCAM4TokenTipMessage,
    isInGroupShow,
    isSimpleTippingMessage,
    isSpotlight,
    isWishTippingMessage,
    message,
    messageBadge,
    metadata,
    username,
  ]);

  if (isTippingMessage) {
    return (
      <div
        className={classnames('message-container', { 'message-container--my-message': isMineMessage })}
      >
        <div className="message-content tipping-content">
          {getTipMessage()}
        </div>
      </div>);
  }

  if (isWishCompletedMessage && wishOwnerNickname) {
    return (
      <div
        className={classnames('message-container', { 'message-container--my-message': isMineMessage })}
      >
        <div className="message-content">
          <b>{wishOwnerNickname}</b> has completed their Tempting Wish
        </div>
      </div>
    );
  }

  return (
    <div
      className={classnames('message-container', { 'message-container--my-message': isMineMessage })}
    >
      <div className="message-content">
        {(!isMineMessage || !isMobile) && (
          <span className="message-owner-username">
            {messageBadge && <img alt="badge" className="message-badge message" src={messageBadge} />}
            <SocialIcon source={source} /> {getDisplayName(username)}:&nbsp;
          </span>
        )}
        <span>
          <ViewDraftjsText
            allAnchors={anchors}
            metadata={metadata}
            text={propsMessage}
          />
        </span>
      </div>
    </div>
  );
};

export default observer(ChatMessage);
